import { c as _c } from "react/compiler-runtime";
import { WithClassName, WithOnChange } from '@/types/component';
import { QueryOrdering } from '@/api/generated/model';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/comps/primitives/select';
import React, { ReactNode } from 'react';
import { SelectItemType } from '@/types/userIntell/chartView';
import { translateSafe } from '@/utils/translations';
import { Activity, Signature } from 'lucide-react';
import { selectItemIconSize } from '@/comps/userIntelligence/constants';
type SortbySelectProps = WithOnChange<QueryOrdering['by']> & WithClassName & {
  value: QueryOrdering['by'];
  items?: {
    value: string;
    title: string;
    icon: ReactNode;
  }[];
  container?: Element | null;
};
export const SortbySelect = t0 => {
  const $ = _c(31);
  const {
    value,
    onChange,
    className,
    container,
    items
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== className || $[1] !== container || $[2] !== items || $[3] !== onChange || $[4] !== value) {
    const selectItems = getSortBySelectItems();
    T1 = Select;
    t4 = value;
    if ($[13] !== onChange) {
      t5 = e => onChange?.(e as QueryOrdering['by']);
      $[13] = onChange;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <SelectValue placeholder="users" />;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    if ($[16] !== className) {
      t6 = <SelectTrigger className={className}>{t7}</SelectTrigger>;
      $[16] = className;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    T0 = SelectContent;
    t2 = "z-1500";
    t3 = container;
    t1 = items ? items.map(_temp) : selectItems.map(_temp2);
    $[0] = className;
    $[1] = container;
    $[2] = items;
    $[3] = onChange;
    $[4] = value;
    $[5] = T0;
    $[6] = T1;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    T0 = $[5];
    T1 = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
  }
  let t7;
  if ($[18] !== t1) {
    t7 = <ul>{t1}</ul>;
    $[18] = t1;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== T0 || $[21] !== t2 || $[22] !== t3 || $[23] !== t7) {
    t8 = <T0 className={t2} container={t3}>{t7}</T0>;
    $[20] = T0;
    $[21] = t2;
    $[22] = t3;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== T1 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t8) {
    t9 = <T1 value={t4} onValueChange={t5}>{t6}{t8}</T1>;
    $[25] = T1;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
};
function getSortBySelectItems(): SelectItemType<QueryOrdering['by']>[] {
  return [{
    value: 'n_interactions',
    title: translateSafe('variable', 'interactions')
  }, {
    value: 'alphabetical',
    title: translateSafe('variable', 'alphabetical')
  }];
}
function getSelectItemIcon(sortBy: QueryOrdering['by']): ReactNode {
  if (sortBy === 'alphabetical') return <Signature size={selectItemIconSize} />;
  return <Activity size={selectItemIconSize} />;
}
function _temp(item) {
  return <li key={item.value}><SelectItem value={item.value}><div className="flex items-center gap-1">{item.icon}<p>{item.title}</p></div></SelectItem></li>;
}
function _temp2(item_0) {
  return <li key={item_0.value}><SelectItem value={item_0.value}><div className="flex items-center gap-1">{getSelectItemIcon(item_0.value)}<p>{item_0.title}</p></div></SelectItem></li>;
}